<app-kontable
      title = "{{ 'sourceSystemList.sectionTitle' | translate }}"
      [columns] = "['id', 'name', 'description', 'host_id']"
      [titles] = "['common.id', 'common.name', 'common.description', 'common.host_id']"
      [showInfoButton]="false"
      [showRecoverButton]="true"
      [showGlobalFilter]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [source]="sourceSystemService.sourceSystems"
      (onAdd)="showAddOrEditDialog($event)"
      (onEdit)="showAddOrEditDialog($event)"
      (onRemove)="delete($event)"
      [(fireNewDataAvailable)]="newDataAvailable"
      (onCancelDetail)="sourceSystemService.sourceSystemEditing = null"
></app-kontable>

<p-dialog
      *ngIf="sourceSystemService.sourceSystemEditing"
      [width]="500"
      [(visible)]="sourceSystemService.sourceSystemEditing"
      header="{{modalTitle}}"
      showEffect="fade"
      [modal]="true"
      (onHide)="onDialogHide()">
    <kv-sourceSystem-form
              [dialogBoxSourceSystem]="sourceSystemService.sourceSystemEditing"
              (sourceSystemAdded)="sourceSystemAdded($event)"
              (sourceSystemUpdated)="sourceSystemUpdated($event)">
    </kv-sourceSystem-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/source-system/source-system.component.html